import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDeployAuth } from "../../context/DeployAuthContext";

/**
 * Guards RivieraDeploy dashboard routes — redirects to /deploy/login when unauthenticated (RD-0048).
 */
function DeployProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useDeployAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center bg-black text-silver-light px-4">
        <div className="animate-pulse space-y-4 w-full max-w-2xl">
          <div className="h-8 bg-gray-800 rounded w-1/3 mx-auto" />
          <div className="h-32 bg-gray-900 rounded border border-gray-800" />
          <div className="h-24 bg-gray-900 rounded border border-gray-800" />
        </div>
        <p className="mt-6 text-silver-medium text-sm">Loading deploy session…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/limelite/deploy/login" replace state={{ from: location }} />;
  }

  return children;
}

export default DeployProtectedRoute;
